import React, { useEffect, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import { ResponsivePie } from "@nivo/pie";
import { ReactComponent as ArrowDownIcon } from "../../../build/images/arrowdownmanager.svg";
import { ReactComponent as ArrowUpIcon } from "../../../build/images/arrowupmanager.svg";
import { ReactComponent as LoadingView } from "../../../build/images/loadingmanagerintentions.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { useSelector } from "react-redux";
import { Tooltippy } from "../../../actions/Tippy";

let colors = [
  "#5E35B1",
  "#6D4C41",
  "#F4511E",
  "#646464",
  "#1E88E5",
  "#43A047",
  "#FFB300",
  "#C0CA33",
  "#D81B60",
  "#C90000",
  "#008908",
  "#F2BD00",
  "#455CC7",
];

function gerar_cor_hexadecimal() {
  return (
    "#" +
    parseInt(Math.random() * 0xffffff)
      .toString(16)
      .padStart(6, "0")
  );
}

// {
//   "id": 1,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 2,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 3,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 4,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 5,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 6,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 7,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 8,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 9,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 10,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 11,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 12,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// },
// {
//   "id": 13,
//   "label": 'datum.nomegrupo',
//   "value": 12,
//   "color": gerar_cor_hexadecimal()
// }

let data = [];
let countIntentions = 0;
let intentionsDataFiltered = 0;

export default function CardChannelDigital({ title, media, classname = "" }) {
  const DataIntentions = useSelector((state) => state.datamanagerintentions);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const [pageScroll, setPageScroll] = useState(1);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const [intentionData, setIntentionsData] = useState([]);

  useEffect(() => {
    if (DataIntentions.length !== 0 && FiltersManager.is_active) {
      let jsonRefactored = [];
      data = [];
      countIntentions = 0;
      jsonRefactored = JSON.parse(DataIntentions);
      jsonRefactored = jsonRefactored.filter((filt) =>
        FiltersManager.filter_manager_service.includes(filt.idgrupo)
      );
      jsonRefactored = jsonRefactored.filter((filt) =>
        FiltersManager.filter_manager_channel.includes(filt.idmidia)
      );
      jsonRefactored = jsonRefactored.filter((filt) => filt.idmidia !== 1);

      jsonRefactored.map((datum, index) => {
        countIntentions += datum.qtde_intencoes;
        data.push({
          id: datum.nomegrupo,
          label: datum.nomegrupo,
          value: datum.qtde_intencoes,
          color: index < 12 ? colors[index] : gerar_cor_hexadecimal(),
        });
      });
      intentionsDataFiltered = jsonRefactored;
      setIntentionsData(jsonRefactored);
    }
  }, [DataIntentions, FiltersManager]);

  const handleScroll = (set) => {
    let qtdPages = Math.ceil(data.length / 6);
    //1 down 1
    if (set === "up" && pageScroll !== 1) {
      setPageScroll(pageScroll - 1);
    } else if (set === "down" && pageScroll <= qtdPages) {
      setPageScroll(pageScroll + 1);
    }
  };

  return (
    <div className={`manager-component__card-status-operators ${classname}`}>
      <div className="manager-component__card-status-operators__title">
        <TextMedium text={title} color="gray" />
      </div>
      <div
        className={
          LoginCompleteReducer.isLoginComplete && countIntentions !== 0
            ? "manager-component__card-status-operators__box"
            : "manager-component__card-status-operators__box-empty"
        }
      >
        {LoginCompleteReducer.isLoginComplete ? (
          countIntentions !== 0 ? (
            <>
              <div className="manager-component__card-status-operators__box-chart">
                <div className="manager-component__card-status-operators__root">
                  <ResponsivePie
                    data={data}
                    //id={'id11245'}
                    id="id"
                    margin={{ top: 10, right: 0, bottom: 10, left: -15 }}
                    startAngle={360}
                    endAngle={-112}
                    innerRadius={0.6}
                    padAngle={0}
                    isInteractive={false}
                    cornerRadius={0}
                    activeInnerRadiusOffset={8}
                    enableArcLinkLabels={false}
                    arcLabelsTextColor="#f6f4f4"
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 0.6]],
                    }}
                    colors={{ datum: "data.color" }}
                  />
                  <div
                    className="manager-component__card-status-operators__root-overlay"
                    style={{
                      paddingLeft:
                        countIntentions < 10
                          ? "41%"
                          : countIntentions > 999
                          ? "31%"
                          : "38%",
                    }}
                  >
                    <strong>{countIntentions}</strong>
                    {/* <span>Operadores</span> */}
                  </div>
                </div>
              </div>
              <div className="manager-component__card-status-operators__box-itens">
                <ul>
                  {data
                    .slice(
                      pageScroll === 1 ? 0 : (pageScroll - 1) * 5,
                      pageScroll * 5
                    )
                    .map((datum, index) => (
                      <div className="box-list__legends" key={index}>
                        <div
                          className="box-list__legends-circle"
                          style={{ backgroundColor: datum.color }}
                        ></div>
                        <Tooltippy content={datum.label}>
                          <span className="box-list__legends-text">
                            {datum.label}
                          </span>
                        </Tooltippy>
                      </div>
                    ))}
                  {data.length >= 6 && (
                    <div className="manager-component__card-preferred-intentions__box-itens__more">
                      <div
                        className={
                          pageScroll === 1
                            ? "manager_arrow-select-disable"
                            : "manager_arrow-select-enable"
                        }
                        onClick={() => handleScroll("up")}
                      >
                        <ArrowUpIcon />
                      </div>
                      <span>
                        {pageScroll}/{Math.ceil(data.length / 5)}
                      </span>
                      <div
                        className={
                          Math.ceil(data.length / 5) === pageScroll
                            ? "manager_arrow-select-disable"
                            : "manager_arrow-select-enable"
                        }
                        onClick={() => handleScroll("down")}
                      >
                        <ArrowDownIcon />
                      </div>
                    </div>
                  )}
                </ul>
              </div>
            </>
          ) : (
            <div className="manager_empty-state">
              <EmptyState />
            </div>
          )
        ) : (
          <div className="card-status_loading small">
            <LoadingView />
          </div>
        )}
      </div>
    </div>
  );
}
